module.exports = __webpack_public_path__ + "static/media/dnn.f1a25ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/dnn.png
// module id = 1776
// module chunks = 157